module.exports = __webpack_public_path__ + "resources/img/img_voice_studio2_m_en.e6b1c4324b39ba23977b30cc166e07fa.png";